// 暂停内部埋点：保留原实现供恢复，不初始化标识、不保存事件队列、不启动定时上报。
// 恢复时需同时启用本文件注释代码与 opensearch/aosAnalytics Store action 的请求。
// const firstVisitor = !localStorage.aos_ana_visitor
// const sessionStart = !sessionStorage.aos_ana_sessionId

// const visitor = localStorage.aos_ana_visitor || (localStorage.aos_ana_visitor = parseInt(Date.now() / 1000).toString(36) + Math.random().toString(36).slice(2))
// const sessionId = sessionStorage.aos_ana_sessionId || (sessionStorage.aos_ana_sessionId = parseInt(Date.now() / 1000).toString(36) + Math.random().toString(36).slice(2))
// const analytics = []
export function reportEvent (name, params, eventParams) {
  // { "analytics":[ { "domain":"https://w", "route":"https://ww", "visitor":"1000", "clickElement":"test", "eventName":"test", "eventParams":[{"address":"test"}], "eventTime":"1709069776", "scrollDepth":"test", "sessionId":"test" } ] }
  // analytics.push({
  //   domain: location.host,
  //   route: location.href,
  //   visitor,
  //   // clickElement:'',
  //   eventName: name,
  //   eventParams,
  //   eventTime: Date.now(),
  //   // scrollDepth:'',
  //   sessionId,
  //   ...params,
  // })
}
// if (firstVisitor) {
//   reportEvent('first_visitor')
// }
// if (sessionStart) {
//   reportEvent('session_start')
// }

// setInterval(() => {
//   if (analytics.length) {
//     const data = {
//       analytics: [...analytics],
//     }
//     analytics.length = 0
//     // console.log('reportEvent', data)
//     window.vueApp.$store.dispatch('opensearch/aosAnalytics/batchCreate', data)
//   }
// }, 2000)
